var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#pattern0_46_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_53",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_53",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_53",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADxklEQVR4nO3dW6hnUxwH8DUYkztFLlGSI8YLueUSXtymzAtT7sMrNSMPFI7bi9K8kAfTyeQSjWmSXGpSaDIko2iMy8swpMbtASlzMD7azlIm6swc//Pfv/9Zv0/96/S/7Mv6nr32ba21S0kppZRSSimlNC2cjKtxH1bimfpaWd/rPls4/ZTSjGAPXIhV+Nqu24bHcQHmZfEPJojrsNn/9yGu6aaZwcwsjNPwrsF7B6dmKLsexDwsx6TZ81vd1+TWMk0Ye2O14Xm2m2duLf8dxgKsM3zdPBdkKDuHsSfW6s9zWX3tHEhXn/ft7txKpsI4H7/3nYapZTiv6VDqTvxjcWzG/NIq3CqeW0rDR1VfiefLJg+F62WMqK4qrenpnGNXvVJagv3xq7gmsV9pBRaJ75LSCtwjvrtKK+rdveieKq3AG+J7vbQC74lvY2kFPhDf+6UV2CC+9aUVeEF8z5dW4CHxPVhagevFd21pBY4R39GlJfhIXJtKa3CnuG4vrcFR2C6eX3BkaVFtrR7No6VV3Y4TP4njx2a3jr/hNnEsK62rXQ5e7TsJvNa1oOy7PELA4fi8xzC24LC+yyEUnIBvewjjG4z1vf4h4UR8McQwtnbz7Hu9R+H85M0hhLG++SOq3Qhlr9oifvssnfiNd/OY1f+suQhjtd/IjgEE0U1jDY7ve71GHhbiEXw3gyC6A4WHs9/67FVl59YqZ23t6vx9bWk4Wf/eVD8br9/NqimllFJKKaWU+tD198ZFeKAOPLZmxF+rcH9dp/mjNhjA8p7ubQxLt27LwgeDQ+tl7Va8jSNKRDgEn2rPJzi4RIOXtevFEgku67tEAri4RBGkGU/f1pUIcFDwURmGpbsfc2CEQM4a2irHd0aEQBb3XQqBLI4QyJK+SyGQJX3nkYEEDCSrrGBVVteyI005O0Igx9WFSRxbIqjP6WjdthJFvV/QutUlityx/2VRCTaYfjfebau2husOh5u064YStPPmKIwUN2gbwz7qovYTjNTvfLb9jJNKZN3mqw1/dMOll1EQ9KkHbQ9Qg3vN3S1jvIwi3DjLj78btsmQR1S7A+fgM6NvS4iLh4PQ3WvGxIB60w7bjrrsB5S5prvnXFv7jYq3cHqZ67qnoeElcW3A5c09YRpn1lHlfug7AVPL8FiIliN9w764Ek/OcHCAmerm9QSuwD59l0NIpq4cn9I9vg5P18EBBnHoPFmn1U3z5jqPWFdoR2wEhzFciqW4AytqdTfxj041E/W9FfU7S+tvut/miA4ppZRSSimlVP7tT59Jd9lsxOfmAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.c29fd425e04495268d0eafd7cca94480.svg";
export { ForwardRef as ReactComponent };